export default {
    form: {
        necessarily: '(обязательно)'
    },
    placeholders: {
        currentPassword:             'Введите старый пароль...',
        newPassword:                 'Введите новый пароль...',
        createPassword:              'Введите пароль',
        createPasswordRepeat:        'Повторите пароль',
        passwordRepeat:              'Повторите новый пароль...',
        chooseManager:               'Выберите менеджера ...',
        chooseCompany:               'Выберите компанию ...',
        chooseDepartment:            'Выберите отдел ...',
        chooseLegal:                 'Выберите юр. лицо ...',
        chooseLegalDepartment:       'Выберите узел оргструктуры ...',
        chooseLegalCell:             'Выберите ячейку штатного расписания ...',
        enterPosition:               'Введите позицию ...',
        enterExplanation:            'Введите обоснование ...',
        chooseEmployee:              'Выберите сотрудника ...',
        enterTown:                   'Введите название города ...',
        currency:                    'Валюта',
        from:                        'От',
        to:                          'До',
        quantity:                    'например 10',
        datepicker:                  'дд.мм.гггг',
        timepicker:                  'чч:мм',
        enterBonuses:                'Введите данные по бонусам и социальному пакету ...',
        specifyDays:                 'Укажите количество дней ...',
        chooseSchedule:              'Выберите график работы ...',
        chooseWorkType:              'Выберите тип занятости ...',
        enterExperienceRequirements: 'Введите необходимые требования к опыту ...',
        enterResponsibilities:       'Введите обязанности ...',
        chooseEducation:             'Выберите образование ...',
        enterEducationComment:       'Введите комментарий к образованию ...',
        enterPersonalQualities:      'Введите личные качества ...',
        chooseLanguage:              'Выберите язык ...',
        proficiency:                 'Уровень владения',
        chooseExperience:            'Выберите стаж ...',
        enterAdditionalInformation:  'Введите дополнительную информацию ...',
        comment:                     'Введите комментарий ...',
        application:                 'Введите заявку ...',
        shortResult:                 'Короткий результат...',
        freeResult:                  'Опишите результат в свободной форме...',
        uploadFile:                  'Загрузить файл...',
        uploadText:                  'Нажмите или перетащите файл в эту область для загрузки',
        uploadHint:                  'Поддерживается загрузка одного файла. Максимальный размер файла %(size)sМБ.',
        emptyFile:                   'Файл не загружен',
        clear:                       'Очистить',
        inputText:                   'Введите название для поиска (минимум 3 символа)',
        inputNameText:               'Введите ФИО для поиска (минимум 3 символа)',
        personState:                 'Выберите состояние',
        salary:                      'Зарплата',
        fee:                         'Гонорар',
        stage:                       'Выберите этап ...',
        requestType:                 'Выберите тип заявки ...',
        metroPositionCodeApproval:   'Если должность уже существует в каталоге, пожалуйста загрузите данные из каталога должностей SAP:',
        chooseInterval:              'Выберите интервал дат',
    },
    requestContinueQuestion: {
        question: 'Продолжить заполнение заявки на вакансию %(position)s?',
        continue: 'Продолжить',
        new: 'Новая заявка',
    },
    rangePicker: {
        today: 'Сегодня',
        thisMonth: 'Этот месяц'
    }
};
